import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';
import { Suspense, lazy } from 'preact/compat';
const PhoneInput = lazy(
    () => import(/* webpackChunkName: "" */ 'react-phone-input-2')
);
const CheckboxGroup = lazy(
    () => import(/* webpackChunkName: "checkbox-group" */ '../../shared/form/checkbox-group')
);


class Component extends BaseComponent {
    constructor(props) {
        super(props);

        this.state = {
            agree: {
                checked: false,
                error: null,
            },
            error: false,
            telephone: {
                value: null,
                error: null,
            },
            view: 1,
        };
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (nextState.telephone.value != this.state.telephone.value) {
            return true;
        }

        if (nextState.telephone.error != this.state.telephone.error) {
            return true;
        }

        if (nextState.agree.checked != this.state.agree.checked) {
            return true;
        }

        if (nextState.agree.error != this.state.agree.error) {
            return true;
        }

        if (nextState.error != this.state.error) {
            return true;
        }

        if (nextProps.view != this.props.view) {
            return true;
        }

        if (nextState.view != this.state.view) {
            return true;
        }

        if (nextProps.unsubscribed != this.props.unsubscribed) {
            return true;
        }

        return false;
    }

    render() {
        return (
            <sms-preferences>
                {this.renderMessage()}
                {this.renderContent()}
                {this.renderButton()}
            </sms-preferences>
        );
    }

    renderMessage = () => {
        if (!this.props.sms) {
            if (!this.props.view || this.props.view == 1) {
                return (<p className='has-padding-20-top'>Sign up for cosmic texts and get 50% OFF any reading!</p>);
            }
        }

        return (<p className='has-padding-20-top'>Update your SMS Preferences here:</p>);
    }

    renderContent = () => {
        if (!this.props.sms) {
            if (!this.props.view || this.props.view == 1) {
                /* eslint-disable max-len */
                /* eslint-disable react/jsx-first-prop-new-line,react/jsx-closing-bracket-location,react/jsx-closing-tag-location */
                return [
                    <row className='is-wrap has-margin-15-top'>
                        <column className='is-9 is-12-mobile'>
                            <label>Enter Your <b>Mobile Number</b> (US Only)</label>
                            <Suspense fallback={<div className='skeleton' />}>
                                <PhoneInput
                                    country='us'
                                    onlyCountries={['us']}
                                    onChange={phone => this.setTelephone(phone)}
                                    placeholder='+1 (999) 555-1234'
                                    value={this.state.telephone.value}
                                    containerClass={
                                        this.state.telephone.error || this.state.optInError ? 'has-error' : null
                                    }
                                />
                            </Suspense>
                        </column>
                        {this.renderPhoneError()}
                        {this.renderOptInError()}
                    </row>,
                    <row className='has-margin-15-top'>
                        <column className='is-1 is-2-mobile'>
                            <Suspense fallback={<div className='skeleton' />}>
                                <CheckboxGroup
                                    name='agree'
                                    checked={this.state.agree.checked}
                                    onChange={this.setAgree}
                                />
                            </Suspense>
                        </column>
                        <column className='is-8 is-10-mobile'>
                            <p className='has-text-size-12 has-line-height-19'>
                                By checking this box and clicking SUBMIT NUMBER, you agree to receive periodic
                                mobile alerts from Tarot.com. Msg & data rates may apply. Text STOP to stop
                                receiving messages. Text HELP for more information. <a href='/terms-of-use'
                                    target='_blank'>Terms & Conditions</a> | <a href='/privacy-policy'
                                    target='_blank'>Privacy Policy</a>
                            </p>
                            <p className='has-text-size-12 has-line-height-19'>Offer is good for one reading</p>
                            {this.renderAgreeError()}
                        </column>
                    </row>,
                ];
                /* eslint-enable max-len,react/jsx-first-prop-new-line,react/jsx-closing-bracket-location,react/jsx-closing-tag-location */
            } else if (this.props.view == 2) {
                return [
                    <p className='has-text-center has-padding-20-top'>Just One More Step</p>,
                    <p className='has-text-center'>
                        We just sent you a text! To claim your<br />50% discount, reply <b>Y</b> on your phone
                    </p>,
                    <p className='has-text-center has-padding-20-top has-text-size-13 has-line-height-20'>
                        Please allow up to an hour for these changes<br />to be reflected in your SMS settings.
                    </p>,
                ];
            }
        } else if (this.props.unsubscribed) {
            return [
                <p className='has-text-center has-padding-20-top'>
                    You have been unsubscribed from Tarot.com text messages.
                </p>,
                <p className='has-text-center has-padding-20-top has-text-size-13 has-line-height-20'>
                    Please allow up to an hour for these changes<br />to be reflected in your SMS settings.
                </p>,
                <p className='has-text-center'>
                    <a href='/member/settings'>Back to Your Account</a>
                </p>,
            ];
        } else if (this.state.view == 1) {
            return [
                <row className='is-wrap has-margin-15-top'>
                    <column className='is-9 is-12-mobile'>
                        <label>Your <b>Mobile Number</b> (US Only)</label>
                        <Suspense fallback={<div className='skeleton' />}>
                            <PhoneInput
                                country='us'
                                onlyCountries={['us']}
                                placeholder={this.formatNumber(this.props.sms.phone_number)}
                                value={this.formatNumber(this.props.sms.phone_number)}
                                containerClass='disabled'
                                disabled
                                onClick={(e) => this.showView(e, 2)}
                            />
                        </Suspense>
                    </column>
                </row>,
                <row className='has-margin-15-top'>
                    <column className='is-9 is-12-mobile'>
                        <button
                            className='button button-warning'
                            onClick={(e) => this.showView(e, 2)}
                        >
                            UPDATE MY NUMBER
                        </button>
                    </column>
                </row>,
                <row className='has-margin-15-top'>
                    <column className='is-9 is-12-mobile'>
                        <a href='#' onClick={this.unsubscribe}>Unsubscribe me from Tarot.com text messages</a>
                    </column>
                </row>,
            ];
        } else if (this.state.view == 2) {
            // eslint-disable-next-line max-len
            /* eslint-disable react/jsx-first-prop-new-line,react/jsx-closing-bracket-location,react/jsx-closing-tag-location */
            return [
                <p>Your Old Number: {this.formatNumber(this.props.sms.phone_number)}</p>,
                <row className='is-wrap has-margin-15-top'>
                    <column className='is-9 is-12-mobile'>
                        <label>Enter Your <b>Mobile Number</b> (US Only)</label>
                        <Suspense fallback={<div className='skeleton' />}>
                            <PhoneInput
                                country='us'
                                onlyCountries={['us']}
                                onChange={phone => this.setTelephone(phone)}
                                placeholder='+1 (999) 555-1234'
                                value={this.state.telephone.value}
                                containerClass={
                                    this.state.telephone.error || this.state.optInError ? 'has-error' : null
                                }
                            />
                        </Suspense>
                    </column>
                    {this.renderPhoneError()}
                    {this.renderOptInError()}
                </row>,
                <row className='has-margin-15-top'>
                    <column className='is-1 is-2-mobile'>
                        <Suspense fallback={<div className='skeleton' />}>
                            <CheckboxGroup
                                name='agree'
                                checked={this.state.agree.checked}
                                onChange={this.setAgree}
                            />
                        </Suspense>
                    </column>
                    <column className='is-8 is-10-mobile'>
                        <p className='has-text-size-12 has-line-height-19'>
                            By checking this box and clicking SUBMIT NUMBER, you agree to receive periodic
                            mobile alerts from Tarot.com. Msg & data rates may apply. Text STOP to stop
                            receiving messages. Text HELP for more information. <a href='/terms-of-use'
                                target='_blank'>Terms & Conditions</a> | <a href='/privacy-policy'
                                target='_blank'>Privacy Policy</a>
                        </p>
                        {this.renderAgreeError()}
                    </column>
                </row>,
            ];
            // eslint-disable-next-line max-len
            /* eslint-disable react/jsx-first-prop-new-line,react/jsx-closing-bracket-location,react/jsx-closing-tag-location */
        }

        return null;
    }

    renderButton = () => {
        if (!this.props.sms) {
            if (!this.props.view || this.props.view == 1) {
                return (
                    <row>
                        <column className='is-9 is-12-mobile has-text-center'>
                            <button className='button' onClick={this.submit}>SUBMIT NUMBER</button>
                        </column>
                    </row>
                );
            } else if (this.props.view == 2) {
                return (
                    <row>
                        <column className='is-12 has-text-center'>
                            <a href='/member/settings'>Back to Your Account</a>
                        </column>
                    </row>
                );
            }
        } else if (this.state.view == 2) {
            return (
                <row className='is-aligned-center'>
                    <column className='is-5 is-7-mobile'>
                        <button className='button' onClick={this.submit}>SAVE NEW NUMBER</button>
                    </column>
                    <column className='is-7 is-5-mobile'>
                        <a href='#' onClick={(e) => this.showView(e, 1)}>Cancel</a>
                    </column>
                </row>
            );
        }

        return null;
    }

    renderPhoneError = () => {
        if (this.state.telephone.error) {
            return (<p className='is-error'>{this.state.telephone.error}</p>);
        }

        return null;
    }

    renderAgreeError = () => {
        if (this.state.agree.error) {
            return (<p className='is-error has-margin-20-bottom'>{this.state.agree.error}</p>);
        }

        return null;
    }

    renderOptInError = () => {
        if (this.props.optInError) {
            return (<p className='is-error-multiline'>{this.props.optInError}</p>);
        }

        return null;
    }

    showView = (e, view) => {
        if (e) {
            e.preventDefault();
        }

        this.setState({ view: view });
    }

    setTelephone = (value) => {
        this.setState({
            telephone: {
                value: value,
                error: null,
            },
        });
    }

    setAgree = (e) => {
        this.setState({
            agree: {
                checked: e.target.checked,
                error: null,
            },
        });
    }

    formatNumber = (number) => {
        return `+${number.substring(0, 1)} (${number.substring(1, 4)}) ${number.substring(4, 7)}-
            ${number.substring(7, 11)}`;
    }

    submit = (e) => {
        e.preventDefault();

        let state = { error: false };

        if (!this.state.telephone.value) {
            state.telephone = {
                value: this.state.telephone.value,
                error: 'Please provide your telephone number',
            };

            state.error = true;
        } else if (!this.state.telephone.value.match(/1[0-9]{10}/)) {
            state.telephone = {
                value: this.state.telephone.value,
                error: 'Please enter a valid US phone number',
            };

            state.error = true;
        } else {
            state.telephone = {
                value: this.state.telephone.value,
                error: null,
            };
        }

        if (!this.state.agree.checked) {
            state.agree = {
                checked: this.state.agree.checked,
                error: 'Please agree before continuing',
            };

            state.error = true;
        } else {
            state.agree = {
                checked: this.state.agree.checked,
                error: null,
            };
        }

        if (!state.error) {
            this.props.optIn({
                phone_number: this.state.telephone.value,
                location: 'account-settings',
            });
        }

        this.setState({ ...this.state, ...state });
    }

    unsubscribe = (e) => {
        e.preventDefault();
        this.props.optOut({
            location: 'account-settings',
        });
    }
}

const mapStateToProps = (state) => ({
    sms: state.sms,
    unsubscribed: state.sms && state.sms.unsubscribed,
    view: state.user && state.user.sms && state.user.sms.view,
    optInError: state.user && state.user.sms && state.user.sms.error,
});

const mapDispatchToProps = (dispatch) => ({
    optIn: (payload) => dispatch({ type: 'sms:opt-in', payload: payload }),
    optOut: (payload) => dispatch({ type: 'sms:opt-out', payload: payload }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);
